import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { GridResultService } from '../../../services/gridresult.service';
import { PageService } from '../../../services/page.service';
import { GridTypeEnum } from '../../../constants/grid-type.enum';
import { GridResultEnum } from '../../../constants/grid-result.enum';
import { Constants } from '../../../constants/constants';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { IUserFetchCriteriaModel } from '../../../entities-api/IUserFetchCriteriaModel';
import { IGlobalEmployeeDetailGridDataModel } from '../../..//entities-api/IGlobalEmployeeDetailGridDataModel';
import { Router } from '@angular/router'
import { IGlobalEmployeeDetailModel } from '../../../entities-api/IGlobalEmployeeDetailModel';
import { IGlobalEmployeeInfoModel } from '../../../entities-api/IGlobalEmployeeInfoModel';
import { environment } from '../../../../environments/environment'


@Component({
  selector: 'opm-search',
  templateUrl: './opm-search.component.html',
  styleUrls: ['./opm-search.component.less'],
  standalone: false
})

export class OpmSearchComponent implements OnInit {
  constructor(
    protected http: HttpClient,
    private gridtype: GridResultService,
    private userService: UserService,
    private page: PageService
  ) { }

  filter: IUserFetchCriteriaModel = this.userService.filter;
  gridDataModel: IGlobalEmployeeDetailGridDataModel;
  visiblNoMatchesFoundPopup: boolean = false;
  gridTypeEnum = GridTypeEnum;
  errorMessage: string;
  isUserAuthorized: boolean;
  readWriteAccessData: boolean;
  totalCount: number;
  currentPage: number;
  isPagingVisible: boolean = false;
  gridResult: string;
  gridResultEnum = GridResultEnum;
  subscription: any;
  users: IGlobalEmployeeInfoModel;
  noMatchesFoundMsg: string = "No matches Found";
  isnotduplicatesync: boolean = true;

  isshowprofile: boolean = false;
  action: string;
  env = environment;
  readOnlyAccessData: boolean = false;
  ngOnInit(): void {
    this.subscription = this.userService.getBellIconClickEmitter()
      .subscribe(() => {
        this.showUpdates();
      });
    this.isPagingVisible = false;

    this.userService.getWriteAccessData().then((response) => {
      this.readWriteAccessData = response;
    })
    this.userService.getReadOnlyAccessData().then((response) => {
      this.readOnlyAccessData = response;
    })

    this.userService.getCurrentUserAsync().then((data: IGlobalEmployeeInfoModel) => {

      this.users = data;
      this.isUserAuthorized = true;
      this.gridDataModel = this.userService.gridDataModel;
      this.currentPage = this.page.currentPage;
      this.totalCount = this.gridDataModel?.TotalCount;

      this.userService.getCreateProfileAccessMasterdata(this.users.Email).then((result) => {

        if (result == true) {
          this.isshowprofile = true;
        }
        else {
          this.isshowprofile = false;
        }

      },
        (response) => {
          this.errorMessage = response.error.Message;
        });;

    },
      (response) => {
        this.isUserAuthorized = false;
        this.errorMessage = response.error.message;
      });

    if (this.userService.showUpdates) {
      this.userService.showUpdates = false;
      this.showUpdates();
    }
  }

  search(): void {
    this.currentPage = 0;
    this.page.CurrentPageNumber(0);
    this.filter.ModifiedOnly = false;
    this.filter.NewOpmUpdatesAvailable = false;
    this.refreshModel();
    this.gridtype.GridresultType(this.gridResultEnum.Search);
    this.gridResult = this.gridtype.gridResult;

  }
  searchDuplicate(): void {
    this.currentPage = 0;
    this.page.CurrentPageNumber(0);
    this.filter.ModifiedOnly = false;
    this.filter.NewOpmUpdatesAvailable = false;
    this.refreshModelDuplicate();
    this.gridtype.GridresultType(this.gridResultEnum.Sync);
    this.gridResult = this.gridtype.gridResult;

  }

  refreshAPIModel() {
    if (!this.isFormValid()) { // Fix for IE, Edge
      return;
    }
    this.userService.getAPIUsers(this.currentPage).then((data: IGlobalEmployeeDetailGridDataModel) => {
      this.gridDataModel = data;
      this.visiblNoMatchesFoundPopup = data.GlobalEmployeeDetails.length === 0;
      this.totalCount = data.TotalCount;
      this.isPagingVisible = data.GlobalEmployeeDetails.length !== 0 && this.totalCount > Constants.PagingConst.RecordsPerPage;
    });
  }


  refreshModel() {
    this.userService.getUsers(this.currentPage).then((data: IGlobalEmployeeDetailGridDataModel) => {
      this.gridDataModel = data;
      this.noMatchesFoundMsg = "No matches Found";
      this.visiblNoMatchesFoundPopup = data.GlobalEmployeeDetails.length === 0;
      this.totalCount = data.TotalCount;
      this.isPagingVisible = data.GlobalEmployeeDetails.length !== 0 && this.totalCount > Constants.PagingConst.RecordsPerPage;
    });
  }
  refreshModelDuplicate() {
    this.userService.getDuplicateUsersSearch(this.currentPage).then((data) => {
      this.gridDataModel = data;
      this.noMatchesFoundMsg = "No matches Found";
      this.visiblNoMatchesFoundPopup = data.GlobalEmployeeDetails.length === 0;
      this.totalCount = data.TotalCount;
      this.isPagingVisible = false;
    });
  }

  showModified(): void {
    if (this.readWriteAccessData == true) {
      this.currentPage = 0;
      this.page.CurrentPageNumber(0);
      this.filter.GlobalPersonId = this.filter.Email = this.filter.PersonId = this.filter.Name = this.filter.EmployeeAlias = this.filter.NewOpmUpdatesAvailable = null;
      this.filter.ModifiedOnly = true;
      this.refreshModel();
      this.gridtype.GridresultType(this.gridResultEnum.Modified);
      this.gridResult = this.gridtype.gridResult;
    }
  }

  showUpdates(): void {
    this.currentPage = 0;
    this.page.CurrentPageNumber(0);
    this.filter.GlobalPersonId = this.filter.Email = this.filter.PersonId = this.filter.Name = this.filter.EmployeeAlias = this.filter.ModifiedOnly = null;
    this.filter.NewOpmUpdatesAvailable = true;
    this.refreshModel();
  }

  exportModified(): void {
    if (this.readWriteAccessData == true) {
      this.http.get(this.userService.export(), { observe: 'response', responseType: 'blob' }).pipe(map((res) => {
        let data = {
          file: res.body,
          filename: res.headers.get('DnldFname')
        }
        res.headers.delete('DnldFname');
        return data;
      }))
        .subscribe(response => this.downLoadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"));
    }
  }
  syncAll(): void {
    this.currentPage = 0;
    this.page.CurrentPageNumber(0);
    this.filter.Email = null;
    this.gridtype.GridresultType(this.gridResultEnum.Sync);
    this.gridResult = this.gridtype.gridResult;
    this.isnotduplicatesync = false;
    this.getDuplicateUsers();
  }
  getDuplicateUsers() {
    this.userService.getDuplicateUsers().then((data) => {
      this.populateUsersData(data)
    })
  }
  getDuplicateUsersSearch() {
    this.userService.getDuplicateUsersSearch().then((data) => {
      this.populateUsersData(data)
    })
  }
  populateUsersData(data) {
    this.gridDataModel = data;
    this.visiblNoMatchesFoundPopup = data.GlobalEmployeeDetails.length === 0;
    this.noMatchesFoundMsg = "No records found";
    this.totalCount = data.TotalCount;
    this.isPagingVisible = data.GlobalEmployeeDetails.length !== 0 && this.totalCount > Constants.PagingConst.RecordsPerPage;
  }
  downLoadFile(data: any, type: string) {

    var blob = new Blob([data.file], { type: type });
    if ((window as any).navigator.msSaveOrOpenBlob) {
      (window as any).navigator.msSaveBlob(blob, data.filename);
    } else {
      const element = document.createElement('a');
      element.setAttribute("href", URL.createObjectURL(blob));
      element.setAttribute("download", data.filename);
      document.body.appendChild(element);
      element.click();
    }

  }
  onPageChange(page: number) {
    this.currentPage = page;
    if (this.gridResult == this.gridTypeEnum.Sync) {
      this.getDuplicateUsers();
    }
    else {
      this.refreshModel();
    }
  }

  isFormValid(): boolean {
    return !!(this.filter.GlobalPersonId ||
      this.filter.Email ||
      this.filter.PersonId ||
      this.filter.Name ||
      this.filter.EmployeeAlias || this.filter.ModifiedOnly);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  TraceLog(): void {

    this.action = Constants.ProfileLogConst.ProfileVisited;
    this.userService.addProfileLogs(this.action);
  }

}
